import React from "react";

const VoiceSkeleton = () => {
    return (
        <div
            className="voice-card"
            style={{
                background: "#f0f0f0",
                cursor: "default",
                opacity: 0.7,
            }}
        >
            <div className="d-flex gap-3 align-items-center">
                <div
                    style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "#ccc",
                        animation: "pulse 1.5s infinite ease-in-out",
                    }}
                ></div>
                <div
                    style={{
                        width: "100px",
                        height: "20px",
                        background: "#e0e0e0",
                        borderRadius: "4px",
                        animation: "pulse 1.5s infinite ease-in-out",
                    }}
                ></div>
            </div>

            <div className="d-flex gap-4 align-items-center">
                <div
                    style={{
                        width: "15px",
                        height: "15px",
                        background: "#d0d0d0",
                        borderRadius: "2px",
                        animation: "pulse 1.5s infinite ease-in-out",
                    }}
                ></div>
                <div
                    style={{
                        width: "15px",
                        height: "15px",
                        background: "#d0d0d0",
                        borderRadius: "50%",
                        animation: "pulse 1.5s infinite ease-in-out",
                    }}
                ></div>
            </div>
        </div>
    );
};

export default VoiceSkeleton;